import { render, staticRenderFns } from "./estadisticas-inicio-venta-articulo.vue?vue&type=template&id=9a6cb9e6&scoped=true&"
import script from "./estadisticas-inicio-venta-articulo.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-inicio-venta-articulo.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-inicio-venta-articulo.vue?vue&type=style&index=0&id=9a6cb9e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6cb9e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VRow,VSkeletonLoader})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
